import { MD_LANGUAGE_SET } from "../const";
import { ReduxAction } from "../actions/language"

export interface ILanguageState {
  current: string;
}

const iLanguage = localStorage.getItem('language') || 'en-gb';

const INITIAL_STATE: ILanguageState = {
  current: iLanguage,
};

const reducer = (state = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case MD_LANGUAGE_SET:
      return { ...state, current: action.payload };
    default:
      return state;
  }
};

export default reducer;
